// src/components/molecules/DateRangeSelector.jsx
import React from "react";
import Stack from "@mui/material/Stack";
import FormDateField from "../atoms/FormDateField";

/**
 * From / To date range selector.
 * Validates: endDate >= startDate, both <= today, max 365 days apart.
 */
export default function DateRangeSelector({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  startError,
  endError,
  disabled,
}) {
  const today = new Date().toISOString().split("T")[0];

  // Max start date = endDate or today
  const maxStart = endDate && endDate < today ? endDate : today;
  // Min end date = startDate
  const minEnd = startDate || undefined;

  return (
    <Stack direction="row" spacing={2}>
      <FormDateField
        label="From"
        value={startDate}
        onChange={onStartChange}
        error={Boolean(startError)}
        helperText={startError}
        max={maxStart}
        required
        disabled={disabled}
      />
      <FormDateField
        label="To"
        value={endDate}
        onChange={onEndChange}
        error={Boolean(endError)}
        helperText={endError}
        min={minEnd}
        max={today}
        required
        disabled={disabled}
      />
    </Stack>
  );
}
